import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';
import { MonotainerTaggingDetailsComponent } from '../../monotainer-tagging-details/monotainer-tagging-details.component';

@Component({
  selector: 'app-tagged-destination',
  templateUrl: './tagged-destination.component.html',
  styleUrls: ['./tagged-destination.component.css']
})
export class TaggedDestinationComponent implements OnInit, OnChanges, OnDestroy {
  @Input() entityDetails: any;
  @Input() widgetData: any;
  @Input() siteId: string;

  tagDetails: any;
  isloader: boolean = false;
  isError: boolean = false;
  private _intervalTimer: any;
  private _afterClosedSubscription: Subscription;
    private _monotainerDetailsSubscription: Subscription;
  constructor(private _dialog: MatDialog, private _service: EntitiesServiceService, private _dataSer: DataService ) { }

  ngOnInit(): void {

  }
  ngOnChanges(): any {
    if (this.entityDetails) {
      this._monotainerDetails();

    }
  }
  ngOnDestroy(): void {
    this._clearTimer();
    this._afterClosedSubscription?.unsubscribe();
    this._monotainerDetailsSubscription?.unsubscribe();  
  }
  tagMonotainer() {
    if (this.tagDetails?.mappingId) {
      const item = {
        site: this.entityDetails?.site?._id, destination: this.tagDetails?.destination?.key, state: this.tagDetails?.properties?.state,
        destinationName: this.tagDetails?.destination?.name, entityId: this.entityDetails?.uniqueId, mappingId: this.tagDetails?.mappingId,
        lanes: this.tagDetails?.zones, id: [this.entityDetails?._id]
      }
      let dialogRef = this._dialog.open(MonotainerTaggingDetailsComponent, {
        width: '30%',
        disableClose: true,
        data: { msg: 'map', taggedDetails: item, siteId: this.siteId }
      });
      this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._monotainerDetails();
          this._dataSer.broadcast('tagRefresh');
        }
      });
    } else {
      return;
    }
  }

  private _refreshApi() {
    if (+this.widgetData?.refreshRate) {
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this._monotainerDetails();
      }, +this.widgetData?.refreshRate);
      this.isError = false;
    }
  }

  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }

  private _monotainerDetails() {
    const reqData = {
      siteId: this.entityDetails?.site?._id ? this.entityDetails?.site?._id : null,
      entityId: this.entityDetails?._id,
      category: 'monotainer',
      type: '2'
    };
    this._monotainerDetailsSubscription = this._service.monotainerDetails(reqData).subscribe(
      {
        next: (result: any) => {
          if (Object.keys(result)?.length) {
            this.tagDetails = result;
          }
          this._refreshApi();
        },
        error: () => {
          this.tagDetails = {};
          this._refreshApi();
        }
      }
    )
  }
}